import { PurchaseEvent } from '@/usecases/event-bus-for-third-party/event'
import { sendToCribnotes } from '@/usecases/event-bus-for-third-party/subscriber/default/handle-purchase/send-to-cribnotes'
import { sendToGA } from '@/usecases/event-bus-for-third-party/subscriber/default/handle-purchase/send-to-ga'
import { sendToWebCustomerTool } from '@/usecases/event-bus-for-third-party/subscriber/default/handle-purchase/send-to-web-customer-tool'

export function handlePurchase(event: PurchaseEvent): void {
  sendToGA(event)
  /**
   * ホテラバ用のGAフォーマットは廃止していきたい
   * なお、廃止すればdefaultのhandlePurchaseと同じになるのでこのファイル自体が不要になる
   * @see https://github.com/Everforth/growthpalette-front/issues/8704
   * @see https://github.com/Everforth/growthpalette-front/issues/8647
   */
  sendToGAWithHlFormat(event)
  sendToWebCustomerTool(event)
  sendToCribnotes(event)
}

/**
 * transactionProducts以下のみdefaultのsendToGAと異なる
 * @see https://github.com/Everforth/growthpalette-front/issues/8263
 */
export function sendToGAWithHlFormat(event: PurchaseEvent): void {
  const payload = convertToHlGAFormat(event)

  payload.forEach((p) => {
    window.dataLayer.push(p)
  })
}

function convertToHlGAFormat(event: PurchaseEvent): PurchaseForHlGA[] {
  const { orderResultSuccessList } = event

  return orderResultSuccessList.map((result) => {
    const subtotal = result.commerceSalesOrder.subtotalPrice
    const tax = result.commerceSalesOrder.tax
    const products = result.order.cartItems.map(cartItem => ({
      item_id: cartItem.skuId,
      item_name: cartItem.name,
      item_variant: cartItem.color || '',
      price: cartItem.unitPrice,
      quantity: cartItem.unitCount,
    }))

    return {
      event: 'e-commerce',
      transactionId: result.commerceSalesOrder.compressedShortId,
      transactionTotal: subtotal,
      transactionTax: tax,
      transactionProducts: products,
      email: event.user.email,
      phone: event.user.tel,
    }
  })
}

interface PurchaseForHlGA {
  event: 'e-commerce'
  transactionId: string
  transactionTotal: number
  transactionTax: number
  transactionProducts: Array<{
    item_id: string
    item_name: string
    item_variant: string
    price: number
    quantity: number
  }>
}
